import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { getPlayedClass } from '../../redux/Game/selectors';
import NavigationBar from '../navigationBar';
import RulesContainer from './components/rulesContainer';
import PhaseContainer from './components/phaseContainer';
import DifficultySelector from './components/difficultySelector';
import CharacterSelector from './components/characterSelector';
import StartButton from './components/startButton';
import PhaseModal from './components/PhaseModal';
import RuleRollModal from './components/RuleRollModal';
import LoginMenu from '../loginMenu';
import colors from '../../utils/colors';

const RootContainer = styled.div`
  height: 283px;
  padding-top: 87px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 1920px;
`;

const SettingsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 2rem;
`;

const StartButtonContainer = styled.div`
  margin: 140px auto 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: calc(100vh - 234px);
  color: ${colors.primaryText};
`;

const MainContainer = styled.div`
  display: flex;
  height: 283px;
  max-height: 283px;
  padding: 10px;
  background: linear-gradient(
    0deg,
    rgba(18, 26, 32, 1) 0%,
    rgba(0, 0, 0, 1) 100%
  );
`;

const BaseContainer = styled.div`
  display: flex;
  flex: 2;
  flex-direction: column;
`;

const NewPlay = () => {
  const playedClass = useSelector((state) => getPlayedClass(state));
  const {
    settings: { showPhaseModal, isStarted, showRuleRollModal },
    user: { showLoginModal },
  } = useSelector((state) => state);
  return (
    <>
      {showPhaseModal && <PhaseModal />}
      {showRuleRollModal && <RuleRollModal />}
      {showLoginModal && <LoginMenu />}

      <RootContainer>
        <NavigationBar />
        <MainContainer
          backgroungColor="#121a20"
          imageUrl={isStarted ? playedClass.imageUrl : null}
          flexDirection="row"
          fullHeight
        >
          {isStarted ? (
            <>
              <RulesContainer />
              <BaseContainer />
              <PhaseContainer />
            </>
          ) : (
            <StartButtonContainer>
              <h4>Pick your way to die</h4>
              <SettingsContainer>
                <DifficultySelector />
                <CharacterSelector />
              </SettingsContainer>
              <StartButton />
              <p>
                Please note that this game is yet to be optimized for smaller
                screens
              </p>
            </StartButtonContainer>
          )}
        </MainContainer>
      </RootContainer>
    </>
  );
};

export default NewPlay;
